import { CardOnFileRow } from "@/features/patient/components/patient-details-drawer";
import { useInitializeStripe } from "@/features/stripe/hooks/useInitializeStripe";
import { StaffCardCapturePanel } from "./StaffCardCapturePanel";
import { Spinner } from "@/components/ui/Spinner";
import { usePatientDetailsContext } from "@/features/patient/context/PatientDetailsContext";
import { useCaptureSession } from "../hooks/useCaptureSession";
import { useCallback } from "react";
import { useCardCaptureSuccessHandler } from "../hooks/useCardCaptureSuccessHandler";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { getFullName } from "@/lib/string";

const StaffCardCaptureContainer = () => {
  const { tenantId } = useTenantRouteContext();
  const { mutateAsync } = useCaptureSession();
  const { patient, patientId } = usePatientDetailsContext();

  const loadSession = useCallback(async () => {
    return await mutateAsync(patientId!);
  }, [mutateAsync, patientId]);

  const { state, handleInitialize, markSuccess } = useInitializeStripe({
    loadSession,
    enabled: patient ? !patient.cardOnFile : null,
  });

  const handleSuccess = useCardCaptureSuccessHandler(
    patientId ?? "",
    tenantId,
    markSuccess,
  );

  const render = () => {
    if (state.phase === "initializing") {
      return <Spinner />;
    }

    if (state.phase === "none" && patient?.cardOnFile) {
      return (
        <CardOnFileRow
          card={patient.cardOnFile}
          patientFullName={getFullName(patient)}
          patientId={patientId ?? ""}
          practiceId={patient.practiceId}
        />
      );
    }

    return (
      <StaffCardCapturePanel
        stripeState={state}
        onSuccess={handleSuccess}
        onRetry={handleInitialize}
        patientId={patientId ?? ""}
      />
    );
  };

  return <div className="px-5 pt-5 pb-6">{render()}</div>;
};

export default StaffCardCaptureContainer;
